import {IAuthState} from '@/interfaces/state';
import {User} from '@/interfaces/user';

export default {
    user: (state: IAuthState): User => state.user,
    token: (state: IAuthState): string => state.token,
    refreshToken: (state: IAuthState): string => state.refreshToken,
};
